import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal, useResource } from "@/comn/hooks";
import { BASE, APIS, SCHEMA_FORM_UCR_NO_SRCH, SCHEMA_GRID_UCR_NO } from "./services/ComnCdService";
import { Link } from "react-router-dom";
export const UcrNumberList = (props: any) => {
    const pgeUid = "ucrNoList";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0013" }],
    });

    const form = {
        ucrNoSrch: useForm({
            defaultSchema: SCHEMA_FORM_UCR_NO_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        ucrNoList: useGrid({
            defaultSchema: SCHEMA_GRID_UCR_NO,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getUcrNoList: useFetch({
            api: (page = grid.ucrNoList.page) => {
                return APIS.getUcrNoList(form.ucrNoSrch.getValues(), page, grid.ucrNoList.size);
            },
            enabled: comnUtils.isEmpty(form.ucrNoSrch.errors) && form.ucrNoSrch.isSubmitted,
            key: [grid.ucrNoList.page, grid.ucrNoList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.ucrNoSrch.getValues(),
                    page: grid.ucrNoList.page,
                    size: grid.ucrNoList.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.ucrNoSrch.handleSubmit(
                () => {
                    grid.ucrNoList.setPage(0);
                    fetch.getUcrNoList.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.ucrNoList.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_UcrNoLst: {
            cell: {
                ucrNo: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: value });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();

        if (params?.lpcoUseYn) {
            console.log(params.lpcoUseYn);
            form.ucrNoSrch.setValue("lpcoUseYn", params.lpcoUseYn);
        }
        if (params?.tansadUseYn) {
            console.log(params.tansadUseYn);
            form.ucrNoSrch.setValue("tansadUseYn", params.tansadUseYn);
        }
    }, []);

    return (
        <Page title={t("T_UCR_NO_LIST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.ucrNoSrch.schema.ucrNo}></Group.Control>
                                <Group.Control {...form.ucrNoSrch.schema.ucrRegmCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.ucrNoSrch.schema.exppnTin}></Group.Control>
                                <Group.Control {...form.ucrNoSrch.schema.exppnNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.ucrNoSrch.schema.imppnTin}></Group.Control>
                                <Group.Control {...form.ucrNoSrch.schema.imppnNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.ucrNoSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.ucrNoList.grid}
                            data={fetch.getUcrNoList.data?.ucrList}
                            render={render.grid_UcrNoLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
